export enum TechOperationAssetEntityType {
  CHEMICAL = "Chemical",
  FERTILISER = "Fertiliser",
  SEED = "Seed",
}
